import { createSelector } from 'reselect';
import { hasDecisionsSelector } from './decisions';
import { hasAllTextsSelector } from './translations';

export const isAuthenticatedAppLoadingSelector = createSelector(
  hasDecisionsSelector,
  hasAllTextsSelector,
  (hasDecisions, hasAllTexts) => !hasDecisions || !hasAllTexts
);
